export enum MapAction {
    CLICK_ON_ROUTE_PATH = 1,
    MOUSEMOVE_ON_ROUTE_PATH = 2,
    MOUSEOUT_ROUTE_PATH = 3
}